import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useWishlist } from "../context/wishlistContext";
import { useCart } from "../context/cartContext";
import Imazhi from "../images/Online shopping-bro.png";

const Wishlist = () => {
  const { wishlistItems, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();

  const handleRemoveFromWishlist = (id) => {
    removeFromWishlist(id);
  };

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <section className="bg-white py-8 antialiased dark:bg-gray-900 md:py-16 flex-grow">
        <div className="mx-auto max-w-screen-xl px-4 2xl:px-0">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
            Wishlist
          </h2>

          {wishlistItems.length === 0 ? (
            <div className="flex flex-col items-center justify-center mt-8">
              <img src={Imazhi} alt="Empty wishlist" className="h-64 w-auto" />
              <p className="mt-4 text-gray-600 dark:text-gray-400 text-lg font-medium">
                Your wishlist is empty. Start adding items you love!
              </p>
            </div>
          ) : (
            <div className="mt-6 space-y-6">
              {wishlistItems.map((item) => {
                let imagePaths = [];
                try {
                  imagePaths = JSON.parse(item.images); // Parse the images field
                } catch (error) {
                  console.error("Error parsing images:", error);
                }

                const filename =
                  imagePaths.length > 0
                    ? imagePaths[0].split(/[\\/]/).pop()
                    : null;

                const isOutOfStock = item.stock === 0; // Check if the product is out of stock

                return (
                  <div
                    key={item.id}
                    className="rounded-lg border border-gray-200 bg-grey-300 p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 md:p-6"
                  >
                    <div className="flex items-center justify-between">
                      {imagePaths.length > 0 && filename ? (
                        <a href={`/product/${item.id}`} className="shrink-0">
                          <img
                            className="h-20 w-20"
                            src={`https://api.theonlysale.com/uploads/images/${filename}`}
                            alt={item.name}
                          />
                        </a>
                      ) : (
                        <div className="h-20 w-20 flex items-center justify-center bg-gray-200 text-gray-500">
                          No Image
                        </div>
                      )}

                      <div className="flex-1 mx-6">
                        <a
                          href={`/product/${item.id}`}
                          className="text-base font-medium text-gray-900 hover:underline dark:text-white"
                        >
                          {item.name}
                        </a>
                        <p className="text-base font-bold text-gray-900 dark:text-white mt-1">
                          ${item.final_price}
                        </p>

                        {/* Display Out of Stock message if applicable */}
                        {isOutOfStock && (
                          <p className="text-sm text-red-600 dark:text-red-400 font-semibold mt-2">
                            Out of Stock
                          </p>
                        )}
                      </div>

                      <div className="flex items-center gap-4">
                        {/* Conditionally render "Move to Cart" button */}
                        <button
                          type="button"
                          onClick={() => handleAddToCart(item)}
                          className={`text-gray-500 hover:text-gray-900 dark:hover:text-gray-300 ${
                            isOutOfStock
                              ? "cursor-not-allowed text-gray-400"
                              : ""
                          }`}
                          disabled={isOutOfStock} // Disable if out of stock
                        >
                          {isOutOfStock ? (
                            <span className="text-sm">Unavailable</span>
                          ) : (
                            <>
                              <i className="fa fa-shopping-cart fa-lg"></i>
                              <span className="sr-only">Move to Cart</span>
                            </>
                          )}
                        </button>

                        <button
                          type="button"
                          onClick={() => handleRemoveFromWishlist(item.id)}
                          className="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-300"
                        >
                          <svg
                            className="h-6 w-6"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                          <span className="sr-only">Remove</span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Wishlist;
